import { useState } from "react";
import { Button } from "components/DesignSystem/Button/Button";
import {
  SetupEntity,
  SetupModal,
} from "v2/components/entityDocuments/SetupModal";

const SINGLE_ENTITY: SetupEntity[] = [{ id: "acme", name: "Acme Labs" }];
const MULTI_ENTITY: SetupEntity[] = [
  { id: "acme", name: "Acme Labs" },
  { id: "globex", name: "Globex Inc" },
  { id: "initech", name: "Initech LLC" },
];
const CURRENT_YEAR = [2025];
const MULTI_YEAR = [2025, 2024];

type Combo = {
  key: string;
  label: string;
  entities: SetupEntity[];
  seasons: number[];
};

const COMBOS: Combo[] = [
  {
    key: "single-year-single-entity",
    label: "Single year · single entity",
    entities: SINGLE_ENTITY,
    seasons: CURRENT_YEAR,
  },
  {
    key: "single-year-multi-entity",
    label: "Single year · multiple entities",
    entities: MULTI_ENTITY,
    seasons: CURRENT_YEAR,
  },
  {
    key: "multi-year-single-entity",
    label: "Multi year · single entity",
    entities: SINGLE_ENTITY,
    seasons: MULTI_YEAR,
  },
  {
    key: "multi-year-multi-entity",
    label: "Multi year · multiple entities",
    entities: MULTI_ENTITY,
    seasons: MULTI_YEAR,
  },
];

export const MultiYearSetup = () => {
  const [activeCombo, setActiveCombo] = useState<Combo | null>(null);

  const closeSetup = () => setActiveCombo(null);

  return (
    <div className="t-flex t-min-h-screen t-flex-col t-items-center t-justify-center t-gap-6 t-bg-surface t-px-6">
      <div className="t-flex t-flex-col t-items-center t-gap-1 t-text-center">
        <span className="t-text-title-h3 t-text-text-60">
          Complete your setup — flows
        </span>
        <span className="t-text-body t-text-text-30">
          Pick a combination to preview its flow.
        </span>
      </div>

      <div className="t-grid t-grid-cols-2 t-gap-3">
        {COMBOS.map((combo) => (
          <Button
            key={combo.key}
            customType="secondary"
            onClick={() => setActiveCombo(combo)}
          >
            {combo.label}
          </Button>
        ))}
      </div>

      {activeCombo && (
        <SetupModal
          key={activeCombo.key}
          open
          onClose={closeSetup}
          entities={activeCombo.entities}
          seasons={activeCombo.seasons}
        />
      )}
    </div>
  );
};
